
import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';
import { SnackBarService } from '@teammood/shared/ui/snack-bar';
import { Team } from '@teammood/team';
import { TeamMemberService } from '@teammood/team';
import { TeamMember } from '@teammood/team';

@Component({
    selector: 'tm-team-member-move',
    templateUrl: './team-member-move-dialog.component.html',
    styleUrls: ['./team-member-move-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
    TranslateModule,
    MatDialogModule,
    MatSelectModule,
    ReactiveFormsModule
]
})
export class TmTeamMemberMoveDialogComponent implements OnInit {
  teamCtrl = new FormControl<Team>(null);
  error: string;

  get selectedTeam() {
    return this.teamCtrl.value;
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: TeamMemberMoveDialogData,
    public dialogRef: MatDialogRef<TmTeamMemberMoveDialogComponent, TeamMember>,
    private teamMemberService: TeamMemberService,
    private snackBarService: SnackBarService,
  ) { }

  async ngOnInit() {
    // error message if not possible to move member
    this.error = undefined;
    if (this.data.teams.length === 0) {
      if (this.data.member.bounced !== null) {
        this.error = 'move_error_bounced';
      } else {
        this.error = 'move_error_no_teams';
      }
    }
  }

  async moveMember() {
    if (this.data.member && this.teamCtrl.value && this.data.teams) {
      const member = await this.teamMemberService.move(this.data.team.id, this.data.member.id, this.selectedTeam.id)
      this.snackBarService.success('teamUpdated');
      this.dialogRef.close(member);
    }
  }
}

export interface TeamMemberMoveDialogData {
  member: TeamMember,
  team: Team,
  teams: Team[]
}